
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});

parcelRegister("hpnxK", function(module, exports) {

$parcel$export(module.exports, "isNotFoundSpaceError", () => $88d658a04ba6cccf$export$bb4f02e6ef6f6e17);
const $88d658a04ba6cccf$export$bb4f02e6ef6f6e17 = (error)=>error.message?.includes('Cannot find space');

});

parcelRegister("1cxtL", function(module, exports) {

$parcel$export(module.exports, "ContentPrerequisitesQuery", () => $32d7b0cfdec8cc05$export$d3cb04278ad9cbd5);

var $d2LG0 = parcelRequire("d2LG0");
const $32d7b0cfdec8cc05$export$d3cb04278ad9cbd5 = (0, $d2LG0.default)`query ContentPrerequisitesQuery($contentId:ID!$missingSpaceKey:Boolean=false$spaceKey:String){content(id:$contentId){nodes{id type space{id key alias}}}space(key:$spaceKey)@skip(if:$missingSpaceKey){id name}}`;

});

parcelRegister("aZE1d", function(module, exports) {

$parcel$export(module.exports, "ContentRedirectQuery", () => $7c86b27540ecb105$export$61e26c9bad803fee);

var $d2LG0 = parcelRequire("d2LG0");
const $7c86b27540ecb105$export$61e26c9bad803fee = (0, $d2LG0.default)`query ContentRedirectQuery($contentId:ID$versionOverride:Int){content(id:$contentId version:$versionOverride){nodes{id title space{id homepageId key alias}history{createdDate}}}}`;

});

parcelRegister("iPRuY", function(module, exports) {

$parcel$export(module.exports, "ContentPrerequisites", () => $eb18cf4dc4cf4350$export$1ff4591c5a23ba79);

var $gwFzn = parcelRequire("gwFzn");

var $diswb = parcelRequire("diswb");

var $inPa6 = parcelRequire("inPa6");

var $7Sm4c = parcelRequire("7Sm4c");

var $dIouf = parcelRequire("dIouf");

var $9wGTI = parcelRequire("9wGTI");

var $ep3mz = parcelRequire("ep3mz");

var $kE2cJ = parcelRequire("kE2cJ");

var $hpnxK = parcelRequire("hpnxK");


var $PrCoC = parcelRequire("PrCoC");

var $dPJCf = parcelRequire("dPJCf");

var $h3KT5 = parcelRequire("h3KT5");

var $gMFJB = parcelRequire("gMFJB");

var $llOcx = parcelRequire("llOcx");

var $jH9vM = parcelRequire("jH9vM");

var $1cxtL = parcelRequire("1cxtL");

var $iElL7 = parcelRequire("iElL7");
const $eb18cf4dc4cf4350$var$useContentPrerequisites = ({ spaceKey: spaceKey, contentId: contentId, contentQueryResult: contentQueryResult, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, skip: skip })=>{
    // Redirect legacy url which doesn't have spaceKey
    const missingSpaceKey = !spaceKey;
    const missingContentId = !contentId;
    // Content is considered missing when we attempted to use contentQueryResult but no data
    // is available due to known or unknown errors. This is only applicable for SSR.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const missingContentSSR = undefined;
    const skipContentPrerequisites = skip || missingContentId || Boolean(contentQueryResult) && !missingContentSSR;
    const contentPrerequisitesQueryResult = (0, $diswb.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $1cxtL.ContentPrerequisitesQuery), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: missingSpaceKey,
            spaceKey: spaceKey
        },
        skip: skipContentPrerequisites
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { data: data, error: error, loading: queryLoading } = skipContentPrerequisites ? contentQueryResult || {} : contentPrerequisitesQueryResult;
    const [{ contentIdLoading: contentIdLoading }] = (0, $ep3mz.usePageState)();
    const loading = queryLoading || contentIdLoading;
    if ((!data || missingContentId) && loading) return {
        isLoading: true
    };
    // Known Apollo bug: Errors are not saved within Apollo in-memory cache
    // https://github.com/apollographql/apollo-client/issues/4806. For restricted spaces and pages,
    // the 403 error is subsequently undefined after retrieval attempt. Restricted spaces means
    // content will be null, but the error might be undefined.
    const isEmptyContent = !loading && !error && data && !data?.content;
    const isTimeoutError = error?.toString().includes('SocketTimeoutException');
    if (error && (0, $dIouf.isUnauthorizedError)(error) || isEmptyContent) {
        if (error) (0, $7Sm4c.markErrorAsHandled)(error);
        // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
        if (isEmptyContent && true) createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                source: 'ContentPrerequisites',
                action: 'returnedEmpty',
                actionSubject: 'content',
                attributes: {
                    contentId: contentId,
                    skip: skip,
                    hadContentQueryData: Boolean(contentQueryResult?.data)
                }
            }
        }).fire();
        return {
            error: error,
            isRestricted: true
        };
    }
    // Catch all for errors, no content and calls that return null/undefined
    // If FF is on, this catches Not Found errors (404) and other errors are handled below
    const content = data?.content?.nodes || [];
    const shouldHandleErrors = !!error && (0, $9wGTI.fg)('confluence_frontend_view_page_experience_errors');
    if (missingContentId || content.length === 0 && !shouldHandleErrors || shouldHandleErrors && (0, $dIouf.isNotFoundError)(error)) return {
        isNotFound: true
    };
    const expectedSpaceKey = content[0]?.space?.alias || content[0]?.space?.key;
    // Checks for case where old / wrong spacekey is provided causing reload
    // on SSR -> SPA transition once the ContentRedirectQuery resolves.
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const wrongSpaceKeyOnSSR = undefined;
    const notFoundSpaceError = error && (0, $hpnxK.isNotFoundSpaceError)(error);
    if (missingSpaceKey || wrongSpaceKeyOnSSR || notFoundSpaceError) {
        (0, $7Sm4c.markErrorAsHandled)(error);
        return {
            isRedirect: true,
            redirectSpaceKey: expectedSpaceKey,
            redirectReason: `CP-noSK:${missingSpaceKey}|wrongSK:${Boolean(wrongSpaceKeyOnSSR)}|noSpace:${Boolean(notFoundSpaceError)}`
        };
    }
    if (error && handleTimeoutError && isTimeoutError) {
        handleTimeoutError(error);
        return {
            error: error,
            isTimeoutError: true
        };
    }
    if (error && handleUnexpectedError) {
        handleUnexpectedError(error);
        return {
            error: error,
            isUnexpectedError: true
        };
    }
    return {};
};
const $eb18cf4dc4cf4350$export$1ff4591c5a23ba79 = ({ children: children, route: route, contentQueryResult: contentQueryResult, passThroughOnLoading: passThroughOnLoading = false, handleUnexpectedError: handleUnexpectedError, handleTimeoutError: handleTimeoutError, versionOverride: versionOverride })=>{
    const [contentId] = (0, $ep3mz.usePageContentId)();
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isTransition = (0, $dPJCf.useIsTransition)();
    const prerequisites = $eb18cf4dc4cf4350$var$useContentPrerequisites({
        spaceKey: spaceKey,
        contentId: contentId,
        contentQueryResult: contentQueryResult,
        handleUnexpectedError: handleUnexpectedError,
        handleTimeoutError: handleTimeoutError
    });
    if (prerequisites.isNotFound) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $h3KT5.NotFoundContained), {
        route: route,
        spaceKey: spaceKey
    });
    const getContentComponent = ()=>{
        if (!isTransition && contentId && (0, $PrCoC.ssrPermissionsErrorHandler).getRestrictedRoute() === 'view' && (0, $9wGTI.fg)('confluence_ssr_permissions_error_handler')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: (0, $PrCoC.ssrPermissionsErrorHandler).getErrorType()
        });
        if (prerequisites.isLoading) return passThroughOnLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gMFJB.ContentExpansionContainer), null, children) : null;
        if (contentId && prerequisites.isRestricted) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $llOcx.UnauthorizedScreen), {
            contentId: contentId,
            accessType: $eb18cf4dc4cf4350$var$getAccessType(prerequisites.error)
        });
        if (prerequisites.isRedirect) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: route.name,
            reason: prerequisites.redirectReason,
            params: {
                contentId: contentId,
                spaceKey: prerequisites.redirectSpaceKey
            }
        });
        if (prerequisites.isTimeoutError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $iElL7.TimeoutErrorScreen), {
            contentId: contentId,
            spaceKey: spaceKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gMFJB.ContentExpansionContainer), null, children);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $jH9vM.ContentRedirect), {
        versionOverride: versionOverride
    }), getContentComponent());
};
function $eb18cf4dc4cf4350$var$getAccessType(error) {
    return error?.graphQLErrors?.[0]?.extensions?.data?.errors?.[0]?.message?.key === 'confluence.content.restricted.inherited' ? 'inherited' : 'view';
}

});
parcelRegister("h3KT5", function(module, exports) {

$parcel$export(module.exports, "NotFoundContained", () => $34086b0c8f89c552$export$db53af9d3dfe8925);

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $lt6Lx = parcelRequire("lt6Lx");

var $gllul = parcelRequire("gllul");

var $gMFJB = parcelRequire("gMFJB");
const $34086b0c8f89c552$export$db53af9d3dfe8925 = ({ route: route, spaceKey: spaceKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lt6Lx.DocumentContentTitle), {
        notFound: true
    }), route === (0, $1NBp8.SPACE_OVERVIEW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.OverviewNotFound), {
        spaceKey: spaceKey
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gllul.NotFound), null));

});
parcelRegister("gMFJB", function(module, exports) {

$parcel$export(module.exports, "ContentExpansionContainer", () => $d38ee66b6872a958$export$ffe4f7ef348542da);
/* styles.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $gwFzn = parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");
const $d38ee66b6872a958$export$ffe4f7ef348542da = /*#__PURE__*/ (0, $gwFzn.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $gwFzn.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $35pXk.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});


parcelRegister("llOcx", function(module, exports) {

$parcel$export(module.exports, "UnauthorizedScreen", () => $3d886ddd51b4b1de$export$6af94d617557e778);

var $gwFzn = parcelRequire("gwFzn");

var $lt6Lx = parcelRequire("lt6Lx");

var $88O8D = parcelRequire("88O8D");

var $hPAXP = parcelRequire("hPAXP");

var $gMFJB = parcelRequire("gMFJB");
const $3d886ddd51b4b1de$export$6af94d617557e778 = /*#__PURE__*/ (0, $gwFzn.memo)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gwFzn.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $88O8D.LoginIfAnonymous), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $gMFJB.ContentExpansionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $lt6Lx.DocumentContentTitle), {
        siteTitleOnly: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $hPAXP.RestrictedPage), props))));

});
parcelRegister("88O8D", function(module, exports) {

$parcel$export(module.exports, "LoginIfAnonymous", () => $d2b0786819b3899c$export$cd1cc7f28314b96a);

var $gwFzn = parcelRequire("gwFzn");

var $1iSzD = parcelRequire("1iSzD");

var $kE2cJ = parcelRequire("kE2cJ");

var $bQm3c = parcelRequire("bQm3c");

var $jEeDd = parcelRequire("jEeDd");
const $d2b0786819b3899c$export$cd1cc7f28314b96a = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    return userId ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        href: (0, $jEeDd.getLoginLink)(),
        usePush: (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)()
    });
};

});


parcelRegister("jH9vM", function(module, exports) {

$parcel$export(module.exports, "ContentRedirect", () => $5b842fead80f6623$export$2ca6584fed43f61);

var $gwFzn = parcelRequire("gwFzn");

var $j1Ss3 = parcelRequire("j1Ss3");

var $dIouf = parcelRequire("dIouf");

var $7Sm4c = parcelRequire("7Sm4c");

var $ep3mz = parcelRequire("ep3mz");

var $cb6fO = parcelRequire("cb6fO");

var $bFVuH = parcelRequire("bFVuH");

var $aZE1d = parcelRequire("aZE1d");
const $5b842fead80f6623$export$2ca6584fed43f61 = ({ versionOverride: versionOverride })=>{
    const [{ contentId: contentId, contentSlug: contentSlug, spaceKey: spaceKey }] = (0, $ep3mz.usePageState)();
    const { data: data, loading: loading, error: error } = (0, $j1Ss3.useQuery)(// eslint-disable-next-line graphql-relay-compat/no-import-graphql-operations -- Preloaded GraphQL Operation
    (0, $aZE1d.ContentRedirectQuery), {
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        },
        context: {
            single: true
        }
    });
    if (loading) return null;
    // UnauthorizedError is a special case here since no specific UI are required for it.
    // In case of an UnauthorizedError the data or content are expected to be empty, and
    // ContentRedirectComponent will handle such case properly.
    if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
    const content = data?.content?.nodes?.[0];
    const space = content?.space;
    const title = content?.title;
    const contentWithSlug = content && {
        ...content,
        slug: (0, $cb6fO.generateSlug)(title),
        spaceKey: space?.alias || space?.key,
        createdDate: content?.history?.createdDate
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bFVuH.ContentRedirectComponent), {
        contentSlugInUrl: contentSlug,
        contentWithSlug: contentWithSlug,
        space: space,
        spaceKeyInUrl: spaceKey
    });
};

});
parcelRegister("bFVuH", function(module, exports) {

$parcel$export(module.exports, "ContentRedirectComponent", () => $40c3e9fb4beb4b02$export$c859cd2f253879ed);

var $gwFzn = parcelRequire("gwFzn");

var $1NBp8 = parcelRequire("1NBp8");

var $6HckY = parcelRequire("6HckY");
var $kE2cJ = parcelRequire("kE2cJ");
var $7zgzO = parcelRequire("7zgzO");
var $4o1RV = parcelRequire("4o1RV");

var $3jwuS = parcelRequire("3jwuS");

var $9wGTI = parcelRequire("9wGTI");
const $40c3e9fb4beb4b02$export$c859cd2f253879ed = /*#__PURE__*/ (0, $gwFzn.memo)(({ contentWithSlug: contentWithSlug, space: space, spaceKeyInUrl: spaceKeyInUrl, contentSlugInUrl: contentSlugInUrl = '' })=>{
    const { match: match } = (0, $gwFzn.useContext)((0, $7zgzO.RoutesContext));
    const { routePolicy: routePolicy } = (0, $4o1RV.useNavigationPolicy)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const shouldRedirectIncorrectSpaceKey = (0, $gwFzn.useCallback)(()=>{
        if (isLivePage) /*
				 * Live Pages exist on the view page route, but render the Confluence editor
				 * The Confluence editor has its own space key redirection logic and move event listeners (via useSpaceKeyWatcher)
				 * Consequently this redirection will clash with the redirects from the editor.
				 */ return false;
        return contentWithSlug && spaceKeyInUrl !== contentWithSlug?.spaceKey;
    }, [
        spaceKeyInUrl,
        contentWithSlug,
        isLivePage
    ]);
    const shouldRedirectIncorrectSlug = (0, $gwFzn.useCallback)(()=>{
        // When current slug in URL does not match with slug in content ==> slug changed
        // Important to decode when compare because react router decodes the params first
        // so contentSlug will be decoded string
        //
        // Live pages will handle its own redirection logic from content slug
        return isLivePage ? false : decodeURIComponent(contentWithSlug?.slug || '') !== decodeURIComponent(contentSlugInUrl);
    }, [
        contentWithSlug?.slug,
        contentSlugInUrl,
        isLivePage
    ]);
    // Don't redirect if we have insufficient information to successfully redirect the user
    if (!contentWithSlug) return null;
    // Do redirect if we should go back to the Space Home Overview Tab
    if (space && contentWithSlug.id === `${space.homepageId}` && match?.name === (0, $1NBp8.VIEW_PAGE).name) {
        const willPushInSelf = !routePolicy || routePolicy.willPushInSelf((0, $1NBp8.VIEW_PAGE).name, match?.params.contentId, (0, $1NBp8.SPACE_OVERVIEW).name, contentWithSlug.id);
        return willPushInSelf ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
            name: (0, $1NBp8.SPACE_OVERVIEW).name,
            params: {
                spaceKey: contentWithSlug.spaceKey,
                contentId: contentWithSlug.id,
                contentSlug: contentWithSlug.slug
            }
        }) : null;
    }
    const isIncorrectSlug = shouldRedirectIncorrectSlug();
    const isIncorrectSpaceKey = shouldRedirectIncorrectSpaceKey();
    // Incorrect slug cannot do redirection in SSR, if there is #anchor fragment in the URL,
    // it will be lost in the redirection, as #anchor fragment is not passed to the server.
    // So we need to do redirection in client side.
    // If the content slug is already fixed in PageState, but URL is incorrect, rewrite URL without
    // triggering route change.
    if (!isIncorrectSpaceKey && (isIncorrectSlug || window.__DELAYED_CONTENT_REDIRECTION__?.contentSlug) && (0, $9wGTI.fg)('confluence_skip_ssr_redirect_incorrect_slug')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6HckY.DelayRedirectionOnClient), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        },
        skipRouteChange: Boolean(!isIncorrectSlug)
    });
    // Don't redirect if we otherwise don't need to
    if (!isIncorrectSpaceKey && !isIncorrectSlug) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), {
        name: match?.name,
        reason: `CRC-wrongSK:${isIncorrectSpaceKey}|wrongSlug:${isIncorrectSlug}`,
        params: {
            ...match?.params,
            spaceKey: contentWithSlug.spaceKey,
            contentId: contentWithSlug.id,
            contentSlug: contentWithSlug.slug
        }
    });
});

});
parcelRegister("6HckY", function(module, exports) {

$parcel$export(module.exports, "DelayRedirectionOnClient", () => $aab50db669fe7470$export$9c627468834548a9);

var $gwFzn = parcelRequire("gwFzn");

var $kE2cJ = parcelRequire("kE2cJ");
const $aab50db669fe7470$export$9c627468834548a9 = (props)=>{
    // In client-side rendering, we can directly render the Redirection component
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $kE2cJ.Redirection), props);
};

});



parcelRegister("iElL7", function(module, exports) {

$parcel$export(module.exports, "TimeoutErrorScreen", () => $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e);
/* TimeoutErrorScreen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $35pXk = parcelRequire("35pXk");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $d2LG0 = parcelRequire("d2LG0");

var $diswb = parcelRequire("diswb");

var $6f0Oj = parcelRequire("6f0Oj");
var $bUlM5 = parcelRequire("bUlM5");
var $5dK2X = parcelRequire("5dK2X");
var $ecnYn = parcelRequire("ecnYn");

var $7hXDW = parcelRequire("7hXDW");

var $inPa6 = parcelRequire("inPa6");

var $8lYIw = parcelRequire("8lYIw");

var $1NBp8 = parcelRequire("1NBp8");

var $ep3mz = parcelRequire("ep3mz");
const $dc6f00ca158cde35$var$timeoutErrorStyles = (0, $ecnYn.xcss)({
    margin: 'auto',
    width: '50%',
    height: '90vh'
});
const $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles = (0, $ecnYn.xcss)({
    border: '1px solid',
    borderColor: 'color.border',
    padding: 'space.500',
    borderRadius: 'border.radius.200'
});
const $dc6f00ca158cde35$var$headingStyles = (0, $ecnYn.xcss)({
    paddingBottom: 'space.200'
});
const $dc6f00ca158cde35$var$bulletStyles = null;
const $dc6f00ca158cde35$var$i18n = (0, $2nPZH.defineMessages)({
    heading: {
        id: "content-prerequisites.timeout-error-screen.heading",
        defaultMessage: "Unable to load page"
    },
    resolutionOptions: {
        id: "content-prerequisites.timeout-error-screen.resolution-options",
        defaultMessage: "To resolve this issue, you may want to:"
    },
    reloadPage: {
        id: "content-prerequisites.timeout-error-screen.reload-page",
        defaultMessage: "Reload this page"
    },
    convertToCloudEditor: {
        id: "content-prerequisites.timeout-error-screen.convert-to-cloud-editor",
        defaultMessage: "<EditLink>Return to edit mode</EditLink> and convert to the <SACLink>cloud editor</SACLink> now"
    },
    removeMacroOrBreakPageContent: {
        id: "content-prerequisites.timeout-error-screen.remove-excerpt-macro-or-break-page-content",
        defaultMessage: "Remove one or more excerpt macros, or break this page content into several smaller pages"
    },
    contactAdmin: {
        id: "content-prerequisites.timeout-error-screen.contact-admin",
        defaultMessage: "If this keeps happening, ask your admin to contact <SupportLink>our Support team</SupportLink> and give them the URL of this page."
    }
});
const $dc6f00ca158cde35$var$TimeoutErrorScreenQuery = (0, $d2LG0.default)`query TimeoutErrorScreenQuery($contentId:ID!){singleContent(id:$contentId){id properties(key:"editor"){nodes{id key value}}}}`;
const $dc6f00ca158cde35$export$f8e8c76e5ae5ca9e = ({ contentId: contentId, spaceKey: spaceKey })=>{
    const [{ contentType: contentType }] = (0, $ep3mz.usePageState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const isBlogpost = contentType === 'blogpost';
    const routeType = isBlogpost ? (0, $1NBp8.EDIT_BLOG) : (0, $1NBp8.EDIT_PAGE);
    const { data: data } = (0, $diswb.useQuery)($dc6f00ca158cde35$var$TimeoutErrorScreenQuery, {
        variables: {
            contentId: contentId
        }
    });
    const linkParams = (0, $gwFzn.useMemo)(()=>({
            contentId: contentId,
            spaceKey: spaceKey,
            contentType: isBlogpost ? 'blog' : 'pages'
        }), [
        contentId,
        spaceKey,
        isBlogpost
    ]);
    // If the editor property is undefined or null, we assume it's TinyMCE even though the missing missing property is not strictly TinyMCE.
    // It's okay to assume this for the purposes of this error screen b/c editor property as null is most likely TinyMCE.
    const editorProperty = data?.singleContent?.properties?.nodes?.[0]?.value;
    const isTinyMCE = !editorProperty || editorProperty === '"v1"';
    (0, $gwFzn.useEffect)(()=>{
        if (isTinyMCE) createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'errorScreen',
                attributes: {
                    customErrorUI: 'tinyMceTimeouts',
                    editorProperty: editorProperty
                }
            }
        })?.fire();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isTinyMCE,
        createAnalyticsEvent
    ]);
    if (!isTinyMCE) return null;
    const editHref = routeType.toUrl(linkParams);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $bUlM5.default), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorStyles,
        direction: "column",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $dc6f00ca158cde35$var$timeoutErrorBorderContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $6f0Oj.default), {
        xcss: $dc6f00ca158cde35$var$headingStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7hXDW.default), {
        size: "large",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $dc6f00ca158cde35$var$i18n.heading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $dc6f00ca158cde35$var$i18n.resolutionOptions)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("ul", {
        className: (0, $35pXk.default)([
            "_n3tdpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $dc6f00ca158cde35$var$i18n.reloadPage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$dc6f00ca158cde35$var$i18n.convertToCloudEditor,
        values: {
            SACLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/confluence-cloud/docs/convert-pages-to-the-new-editor"
                }, chunks),
            EditLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: editHref
                }, chunks)
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), $dc6f00ca158cde35$var$i18n.removeMacroOrBreakPageContent))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $5dK2X.default), {
        as: "p"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $4jR19.default), {
        ...$dc6f00ca158cde35$var$i18n.contactAdmin,
        values: {
            SupportLink: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8lYIw.Link), {
                    target: "_blank",
                    href: "https://support.atlassian.com/contact/#/"
                }, chunks)
        }
    }))));
};

});


parcelRegister("aORIy", function(module, exports) {

$parcel$export(module.exports, "ContentTypesHeader", () => $ff99d36a47469c53$export$e3980b758fe4ea84);

var $gwFzn = parcelRequire("gwFzn");

var $7d2Nc = parcelRequire("7d2Nc");

var $5qUgM = parcelRequire("5qUgM");

var $8nrOs = parcelRequire("8nrOs");


var $lEVfb = parcelRequire("lEVfb");
const $ff99d36a47469c53$export$e3980b758fe4ea84 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $7d2Nc.PageSegmentLoadStart), {
        metric: (0, $5qUgM.OBJECT_HEADER_SEGMENT_METRIC)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($gwFzn))).createElement((0, $8nrOs.ContentTypesHeaderLoader), props));

});
parcelRegister("5qUgM", function(module, exports) {

$parcel$export(module.exports, "CONTENT_TYPES_HEADER_TITLE_SEGMENT", () => $325dcacdd45838d0$export$fd9c234c55ebf87b);
$parcel$export(module.exports, "OBJECT_HEADER_SEGMENT_METRIC", () => $325dcacdd45838d0$export$31dafa10be5579b1);
$parcel$export(module.exports, "DATABASE_HEADER_SUBSEGMENT_METRICS", () => $325dcacdd45838d0$export$13d0f4f758cb96f);
$parcel$export(module.exports, "DATABASE_HEADER_SEGMENT_METRIC", () => $325dcacdd45838d0$export$2afecd1facfcf464);
$parcel$export(module.exports, "SMART_LINK_EMBED_HEADER_SUBSEGMENT_METRICS", () => $325dcacdd45838d0$export$48a0148c0fcdf96);
$parcel$export(module.exports, "SMART_LINK_EMBED_HEADER_SEGMENT_METRIC", () => $325dcacdd45838d0$export$a8f0e1718c3ba46b);
$parcel$export(module.exports, "WHITEBOARD_HEADER_SUBSEGMENT_METRICS", () => $325dcacdd45838d0$export$585906e42509a641);
$parcel$export(module.exports, "WHITEBOARD_HEADER_SEGMENT_METRIC", () => $325dcacdd45838d0$export$de21700de0084df7);

var $jX1qB = parcelRequire("jX1qB");
var $lSOAM = parcelRequire("lSOAM");

var $14SPd = parcelRequire("14SPd");

var $7d41Y = parcelRequire("7d41Y");

var $15M40 = parcelRequire("15M40");
const $325dcacdd45838d0$export$fd9c234c55ebf87b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.CONTENT_TYPES_HEADER_TITLE_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS = [
    $325dcacdd45838d0$export$fd9c234c55ebf87b,
    (0, $7d41Y.FAVOURITE_BUTTON_METRIC),
    (0, $14SPd.RESTRICTIONS_BUTTON_METRIC)
];
const $325dcacdd45838d0$export$31dafa10be5579b1 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.OBJECT_HEADER_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});
const $325dcacdd45838d0$export$13d0f4f758cb96f = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS
];
const $325dcacdd45838d0$export$2afecd1facfcf464 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.DATABASE_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$13d0f4f758cb96f
});
const $325dcacdd45838d0$export$48a0148c0fcdf96 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$a8f0e1718c3ba46b = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SMART_LINK_EMBED_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$48a0148c0fcdf96
});
const $325dcacdd45838d0$export$585906e42509a641 = [
    ...$325dcacdd45838d0$var$CONTENT_TYPES_HEADER_COMMON_SUBSEGMENT_METRICS,
    (0, $15M40.SHARE_BUTTON_PAGE_SEGMENT_LOAD)
];
const $325dcacdd45838d0$export$de21700de0084df7 = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.WHITEBOARD_HEADER_SEGMENT_METRIC_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined,
    until: $325dcacdd45838d0$export$585906e42509a641
});

});
parcelRegister("7d41Y", function(module, exports) {

$parcel$export(module.exports, "FAVOURITE_BUTTON_METRIC", () => $9b3034aec76dfadd$export$ecb802558c1ba05e);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
const $9b3034aec76dfadd$export$ecb802558c1ba05e = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.FAVOURITE_BUTTON_SEGMENT_KEY),
    ssr: Boolean(window.__SSR_RENDERED__) ? {
        doneAsFmp: true
    } : undefined
});

});

parcelRegister("15M40", function(module, exports) {

$parcel$export(module.exports, "SHARE_BUTTON_PAGE_SEGMENT_LOAD", () => $8336b070b3684358$export$8fdec53caa79133c);

var $lSOAM = parcelRequire("lSOAM");
var $jX1qB = parcelRequire("jX1qB");
const $8336b070b3684358$export$8fdec53caa79133c = (0, $lSOAM.createPageSegmentLoadMetric)({
    key: (0, $jX1qB.SHARE_BUTTON_SEGMENT_KEY)
});

});


parcelRegister("8nrOs", function(module, exports) {

$parcel$export(module.exports, "ContentTypesHeaderLoader", () => $7b80359059e5668e$export$17777490bbedaf3a);

var $jmjWc = parcelRequire("jmjWc");

const $7b80359059e5668e$export$17777490bbedaf3a = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "i-H0G",
    name: "ContentTypesHeaderLoader",
    loader: async ()=>(await (parcelRequire("cCmbi"))).ContentTypesHeader
});

});
parcelRegister("cCmbi", function(module, exports) {

let $92fa3d5d8a5c92bf$var$load = (parcelRequire("lhnSv"))(5);
module.exports = Promise.all([
    $92fa3d5d8a5c92bf$var$load("7jBYv"),
    $92fa3d5d8a5c92bf$var$load("05d2I"),
    $92fa3d5d8a5c92bf$var$load("3D26r"),
    $92fa3d5d8a5c92bf$var$load("kRtpG"),
    $92fa3d5d8a5c92bf$var$load("k8hvy"),
    $92fa3d5d8a5c92bf$var$load("34k9U"),
    $92fa3d5d8a5c92bf$var$load("c0RpY"),
    $92fa3d5d8a5c92bf$var$load("dC3sP"),
    $92fa3d5d8a5c92bf$var$load("3xec3"),
    $92fa3d5d8a5c92bf$var$load("7S4dn"),
    $92fa3d5d8a5c92bf$var$load("i3TSs"),
    $92fa3d5d8a5c92bf$var$load("58UdM"),
    $92fa3d5d8a5c92bf$var$load("4Qstt"),
    $92fa3d5d8a5c92bf$var$load("5odbj"),
    $92fa3d5d8a5c92bf$var$load("9L8th"),
    $92fa3d5d8a5c92bf$var$load("dA1E5"),
    $92fa3d5d8a5c92bf$var$load("fwbht"),
    $92fa3d5d8a5c92bf$var$load("h4Nf7"),
    $92fa3d5d8a5c92bf$var$load("2F69B"),
    $92fa3d5d8a5c92bf$var$load("5zDuS"),
    $92fa3d5d8a5c92bf$var$load("leIbB"),
    $92fa3d5d8a5c92bf$var$load("fqZPY"),
    $92fa3d5d8a5c92bf$var$load("9ybBP"),
    $92fa3d5d8a5c92bf$var$load("hP2ev"),
    $92fa3d5d8a5c92bf$var$load("6FRhD"),
    $92fa3d5d8a5c92bf$var$load("dTsOE"),
    $92fa3d5d8a5c92bf$var$load("kjZZD"),
    $92fa3d5d8a5c92bf$var$load("aGZFn"),
    $92fa3d5d8a5c92bf$var$load("g9CVe"),
    $92fa3d5d8a5c92bf$var$load("i5Fj1"),
    $92fa3d5d8a5c92bf$var$load("dq8Jz"),
    $92fa3d5d8a5c92bf$var$load("4Bp5z"),
    $92fa3d5d8a5c92bf$var$load("aZinD"),
    $92fa3d5d8a5c92bf$var$load("cyGuT"),
    $92fa3d5d8a5c92bf$var$load("jXE7i"),
    $92fa3d5d8a5c92bf$var$load("2Qrvo"),
    $92fa3d5d8a5c92bf$var$load("2iqdN"),
    $92fa3d5d8a5c92bf$var$load("72Gwk"),
    $92fa3d5d8a5c92bf$var$load("6qah4"),
    $92fa3d5d8a5c92bf$var$load("ffEVr"),
    $92fa3d5d8a5c92bf$var$load("c6MKV"),
    $92fa3d5d8a5c92bf$var$load("joJy8"),
    $92fa3d5d8a5c92bf$var$load("aHE9G"),
    $92fa3d5d8a5c92bf$var$load("1Qnbq"),
    $92fa3d5d8a5c92bf$var$load("KS1sL")
]).then(()=>parcelRequire('JJ6wk'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});




parcelRegister("lEVfb", function(module, exports) {

$parcel$export(module.exports, "useIsEditorToolbarDockedAtTop", () => $8a729a72887c33f8$export$39186427447356b2);
/**
 * @graphql cc
 */ 
var $diswb = parcelRequire("diswb");

var $d2LG0 = parcelRequire("d2LG0");

var $dIouf = parcelRequire("dIouf");

var $6mKj3 = parcelRequire("6mKj3");

var $7Sm4c = parcelRequire("7Sm4c");
const $8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery = (0, $d2LG0.default)`query useIsEditorToolbarDockedAtTopEditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}`;
const $8a729a72887c33f8$export$39186427447356b2 = ({ defaultDockedAtTop: defaultDockedAtTop = false } = {})=>{
    const { data: data, loading: loading, error: error } = (0, $diswb.useQuery)($8a729a72887c33f8$var$useIsEditorToolbarDockedAtTopEditorPreferencesQuery, {
        fetchPolicy: 'cache-only',
        skip: (0, $6mKj3.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')
    });
    if ((0, $6mKj3.expValEqualsNoExposure)('platform_editor_controls', 'cohort', 'control')) return true;
    if (loading) // while loading use the default docking preference
    return defaultDockedAtTop;
    if (error) {
        if ((0, $dIouf.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        // couldn't query for user's docking preference, use the default docking preference
        return defaultDockedAtTop;
    }
    // get graphql user preference value
    const dockingPreference = data?.userPreferences?.confluenceEditorSettings?.toolbarDockingInitialPosition;
    if (dockingPreference === 'top') return true;
    if (dockingPreference === 'none') return false;
    return defaultDockedAtTop;
};

});


var $7a6716ecb8f47e20$exports = {};

(parcelRequire("fzRTW")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"c0RpY\",\"NativeCollabComponent.69e00edb.js\",\"KS1sL\",\"ContentTypesHeader.cae41a30.js\",\"23MlT\",\"RevertEditorDialog.c15184d3.js\",\"aHE9G\",\"vendors~editor_atlaskit.fa38c7b3.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"2iqdN\",\"EditorContentStateComponent.b453cc75.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"RU02s\",\"ConvertToLivePageDialog.81b8b51e.js\",\"9mi9f\",\"BannerSpacer.581de0f1.js\",\"5joXW\",\"GuestRequestToUpgradeToUser.7da96066.js\",\"1epse\",\"GuestRequestToUpgradeLearnMoreModal.443ac364.js\",\"8Txex\",\"Guest-Avatar.ebdf69f1.svg\",\"2wyTK\",\"Team-Avatars.4f1b07ad.svg\",\"3wN5D\",\"ExternalSpaceLozenge.6d51a964.js\",\"j3iEF\",\"CommentAddPromptNudgeText.5f1b8fa4.js\",\"lwUFR\",\"RequestAccessForUnassignedGuest.9a35b3a7.js\",\"aad5M\",\"Collaboration-Bike.8735a1c6.svg\",\"7Ni3R\",\"GuestOnboardingModal.88285666.js\",\"WYAWv\",\"Guest-Onboarding-Light.8e788fbd.svg\",\"4rpM2\",\"Guest-Onboarding-Dark.f055cab3.svg\",\"ktyyJ\",\"TrialFlags.29e967aa.js\",\"cmcKh\",\"TrialFlags.0d9edc2f.js\",\"4yUSc\",\"PremiumLozenge.1ef1822e.js\",\"ePA5l\",\"Lozenge.156d3474.js\",\"cPGpO\",\"premiumLozenge.aa9b0435.svg\",\"fqBFU\",\"ReverseTrialLozenge.93dcc19b.js\",\"1HAEl\",\"ReverseTrialListItem.37c62263.js\",\"iaptT\",\"Page.214df7eb.js\",\"kG8pF\",\"ViewPage.7d406f94.js\",\"i9ToQ\",\"ViewPage.bc992a00.js\",\"4YF8c\",\"EditPage.993dca19.js\",\"lPCqB\",\"FullPageEditorComponent.b1011b8a.js\",\"gGI57\",\"Page.43016ef1.js\",\"1Qnbq\",\"ReadTimePopup.52bfd6e2.js\",\"i1TuF\",\"cs.2190cb07.js\",\"eEPT4\",\"da.02eaca38.js\",\"gkfGT\",\"de.90355bf8.js\",\"6kSRw\",\"en.32193a4b.js\",\"2dFTF\",\"en_GB.09598cb2.js\",\"auo6z\",\"en_ZZ.f14ca7c2.js\",\"685rk\",\"es.8fa0593c.js\",\"fp6pG\",\"fi.71fd59df.js\",\"6bt8l\",\"fr.40c5717d.js\",\"jjvsl\",\"hu.50ccd7da.js\",\"bAfbH\",\"it.e0e7a6ba.js\",\"5Q9X0\",\"ja.2dfec41f.js\",\"ePkyJ\",\"ko.0b1ec89d.js\",\"hpdFn\",\"nb.b2e768d2.js\",\"8qW90\",\"nl.7f781ad8.js\",\"a1OSV\",\"pl.ca25a045.js\",\"8AvOI\",\"pt_BR.eb536358.js\",\"jxu37\",\"ru.3bbb4cd9.js\",\"10YQF\",\"sv.b02b2c4a.js\",\"daBgp\",\"tr.1172519d.js\",\"bI6N0\",\"th.b72c3249.js\",\"3Qhls\",\"uk.c5a9160e.js\",\"dgXIC\",\"vi.98dce50e.js\",\"jh4hi\",\"zh_TW.79a7157d.js\",\"2AL0H\",\"zh.29b1c23a.js\",\"36rXN\",\"MovePageDialog.203d95d6.js\",\"lnCW7\",\"ExternalCollaboratorInSpaceNotify.0768fceb.js\",\"j02A7\",\"ViewExternalCollaboratorsLink.aaaf4419.js\",\"l5XQ1\",\"ViewSpaceExternalCollaboratorsDialog.131ddef7.js\",\"h4Nf7\",\"ExternalUserLozenge.546379e0.js\",\"aHE9G\",\"vendors~editor_atlaskit.fa38c7b3.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"hA2SB\",\"GroupAndUserItem.63b46522.js\",\"hwiu3\",\"NavigationLockout.6ac66ad3.js\",\"iHlO3\",\"empty-filter.16dda5ac.svg\",\"c6MKV\",\"stable_vendors.1dfa4f36.js\",\"ffEVr\",\"vendors~editor_icon.92bb159e.js\",\"8DoxJ\",\"modal.3fd9f746.js\",\"3XMOA\",\"modal.09301316.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.62693001.js\",\"kPQBd\",\"CompletionFlag.d73c19f6.js\",\"dA1E5\",\"ShareButton.12b748cc.js\",\"9ybBP\",\"mention.2bf41d36.js\",\"fqZPY\",\"mention.runtime.9c1ade46.js\",\"ftJgg\",\"ShareButton.f5289ded.js\",\"aZinD\",\"vendors.0386fed2.js\",\"j4POW\",\"GroupAndUserItem.6f0fcdd7.js\",\"fqZPY\",\"mention.runtime.9c1ade46.js\",\"lookM\",\"user-header-for-space-with-guests-Light.1b10bf7d.svg\",\"2GHvs\",\"user-header-for-space-with-guests-Dark.3d8c1f10.svg\",\"ltXeo\",\"PageTree.426ae1e0.js\",\"dviIw\",\"CollapsibleSection.87723006.js\",\"dkv9z\",\"PageTreeAfterIcon.541ae001.js\",\"9F7vX\",\"CreateContentPopover.18986a3b.js\",\"bAbyV\",\"top-nav.5a6babce.js\",\"f1WN5\",\"top-nav.ff89effc.js\",\"7ZpqL\",\"top-nav.4e7cc26e.js\",\"dwffN\",\"GlobalCreateContentPopoverMenu.a78ae85f.js\",\"kiDFE\",\"CreateSpaceMenuItem.ea370925.js\",\"cZgEZ\",\"ContentTreeOnboarding.0a72cc8d.js\",\"6fU2k\",\"drag-handle.629d4432.js\",\"lWi9V\",\"CreateSpaceMenuItemNav3.1b2a8415.js\",\"3tVyh\",\"CreateSpacePlusButton.9425428f.js\",\"dLkMK\",\"FullPageEditorComponent.38305f1c.js\",\"np2ZB\",\"NonMasteredUserModal.9a34fe35.js\",\"j2eUy\",\"nonMasteredUserModalSplashImage.90ba8397.svg\",\"hq1Iv\",\"masteringFlowSplashImage.1f9bd0cc.svg\",\"2a8Ft\",\"is-supported.fbac545d.js\",\"7p6A4\",\"is-supported.becb4292.js\",\"cvmv4\",\"esm.cfbad62d.js\",\"hFfgY\",\"esm.2186c1b5.js\",\"fKpYd\",\"esm.fdbdb29e.js\",\"12s7O\",\"esm.af4ff8f4.js\",\"2Mhbz\",\"cardWithMediaClient.28ad5b7a.js\",\"eYDcz\",\"modal.0d3f7674.js\",\"lFp1i\",\"FullPageEditorComponent.2efc843f.js\",\"daoWf\",\"LoomCrossSellPopupCardImage.6e60c328.png\",\"jBwbI\",\"LoomMigrationModalManager.bdc7286e.js\",\"3jZMP\",\"loomMigrationModalImage.fa8ef03b.svg\",\"1wrZ9\",\"vector.07efb279.svg\",\"014Eq\",\"pageHeaderSpotlightImage.b1e98e59.png\",\"ipnbL\",\"createSpotlightImage.f64dc988.png\",\"2oVPY\",\"ContextualCreateContentPopoverMenu.b789f086.js\",\"hr1db\",\"DatabaseGAOnboarding.fdc4cc79.svg\",\"h4qu8\",\"LiveDocsIntroGif.d2fc0787.gif\",\"j7hKO\",\"LiveDocIntroGADark.45e6357d.svg\",\"7yu5V\",\"LiveDocIntroGALight.8a32f41a.svg\",\"5TJ4V\",\"WhiteboardExperimentSpotlightImage.49c94c1b.svg\",\"iUB8p\",\"WhiteboardsPaywall.cf2c63af.svg\",\"1TlSS\",\"WhiteboardsPaywallDark.0948bce6.svg\",\"e9W8R\",\"ContextualCreateContentPopoverMenu.4e859924.js\",\"4Bp5z\",\"ReadTimePopup.3c029061.js\",\"aGZFn\",\"modal.5010df70.js\",\"cp1n9\",\"TreeBottomCreateButton.126659d4.js\",\"4Dabn\",\"ContextualCreateContentPopoverMenu.f40912c2.js\",\"dGk3x\",\"GlobalFeedbackCollector.5c3e76a5.js\",\"cyGuT\",\"feedback-collector.b1919a90.js\",\"aHE9G\",\"vendors~editor_atlaskit.fa38c7b3.js\",\"joJy8\",\"vendors~editor_atlaskit.runtime.c6bf66de.js\",\"aZinD\",\"vendors.0386fed2.js\",\"c6MKV\",\"stable_vendors.1dfa4f36.js\",\"iPz8n\",\"GlobalFeedbackCollector.d8df6b85.js\",\"1RolH\",\"EmojiPickerComponent.33a787e5.js\",\"etwBB\",\"activity.d3402161.js\",\"a2rZD\",\"custom.fc3cd725.js\",\"ePm95\",\"flags.40431f78.js\",\"kJcWg\",\"food.473b199a.js\",\"cUIjD\",\"frequent.67753c39.js\",\"4tIwu\",\"nature.96f73db7.js\",\"1sEV4\",\"objects.ee88e397.js\",\"6Tafs\",\"people.9a055314.js\",\"6j8nK\",\"symbols.fdc6ed64.js\",\"i1sL7\",\"travel.5460db1e.js\",\"36ctu\",\"productivity.bb738ebf.js\",\"bEnB5\",\"modal.74fde4f3.js\",\"fhU7k\",\"esm.50a6c5c3.js\",\"4hOv8\",\"esm.bc27d7ff.js\",\"gg6T0\",\"modal.e56b33bc.js\",\"6aruy\",\"media-client-react.88ecf091.js\",\"fsZ6i\",\"media-client-react.6ee34dde.js\",\"jWyan\",\"angle-brackets-icon.0108617d.js\",\"4M7W5\",\"mediaInlineCard.11bd096a.js\",\"jDjSj\",\"16.8a4cce0e.js\",\"8059b\",\"16.afe6487f.js\",\"hPalR\",\"16.93dce164.js\",\"2fk6g\",\"16.bea78523.js\",\"dil5i\",\"24.e2acaae5.js\",\"fYhfO\",\"modal.4e87ffc8.js\",\"iIRyn\",\"modal.runtime.fd384371.js\",\"iIRyn\",\"modal.runtime.fd384371.js\",\"iP5Bv\",\"mediaInlineAnalyticsErrorBoundary.da71b2bb.js\",\"fwuXj\",\"cardWithMediaClient.317dad77.js\",\"8Ozg8\",\"inlinePlayer.7538d68b.js\",\"cXPC0\",\"EmbedModal.a727c385.js\",\"dUKeO\",\"vid-full-screen-on.89bfbdcb.js\",\"iiqDR\",\"vid-full-screen-off.edfa2cde.js\",\"5rLJa\",\"vid-pause.b74a9dab.js\",\"eILYA\",\"LinkCards.4a9a2a5a.js\",\"6dDCB\",\"outgoing-sound.ec5fde53.js\",\"h9Mrx\",\"video.6b53aa5b.js\",\"P5iE2\",\"24.874d8c90.js\",\"42vdC\",\"24.4866b870.js\",\"9Bu2S\",\"24.1eba1b1c.js\",\"8pE8S\",\"24.4b97cbb2.js\",\"ivQYH\",\"24.272a2b94.js\",\"7a9CL\",\"24.f46d75b2.js\",\"8mzoy\",\"24.b3fbae03.js\",\"bjzRn\",\"24.44a1e682.js\",\"fYi1a\",\"24.8dbe60cd.js\",\"fqrMn\",\"24.60e4661d.js\",\"hzK1f\",\"24.98083536.js\",\"e53Dv\",\"vid-play.9e8ddef6.js\",\"6gqpV\",\"GlobalFeedbackCollector.493c1808.js\",\"5doAZ\",\"DatePicker.fc4d895a.js\",\"9KJWc\",\"clipboard.256435a8.js\",\"1qUWs\",\"media-viewer-error-boundary.445b2080.js\",\"7Vmxp\",\"table.f8779bf1.js\",\"h9hWQ\",\"SimpleEmoji.0213c7c9.js\",\"eFHVS\",\"extensibility.bc55036e.js\",\"djfev\",\"ConfigPanelFieldsLoader.88dae015.js\",\"6FRhD\",\"modal.d7e76543.js\",\"hP2ev\",\"modal.runtime.046de774.js\",\"eoIpr\",\"add-circle.bdecb931.js\",\"hP2ev\",\"modal.runtime.046de774.js\",\"9p2N9\",\"ui.2a29b85d.js\",\"cCWZm\",\"dropzone.a0930126.js\",\"lE3cg\",\"media-picker-analytics-error-boundary.522e0176.js\",\"cKkZK\",\"media-viewer-error-boundary.8610fd88.js\",\"bHwQq\",\"archive.fd275619.js\",\"9vSeI\",\"audio.7b721c3b.js\",\"8PuzS\",\"archive.29f79635.js\",\"lixGB\",\"78-EUC-H.51d0c3f9.js\",\"fH2pk\",\"78-EUC-V.64ff1cfd.js\",\"kZB45\",\"78-H.0ed13b16.js\",\"6BxSI\",\"78-RKSJ-H.dc86b34e.js\",\"i9zPw\",\"78-RKSJ-V.82830549.js\",\"8Qq8X\",\"78-V.b650b3b6.js\",\"hUHQJ\",\"78ms-RKSJ-H.8d99de38.js\",\"4Y4SR\",\"78ms-RKSJ-V.d9f17393.js\",\"axQaS\",\"83pv-RKSJ-H.f8767ab6.js\",\"hh6Ks\",\"90ms-RKSJ-H.d832d6a6.js\",\"gyPUO\",\"90ms-RKSJ-V.260dbffb.js\",\"aduQJ\",\"90msp-RKSJ-H.364f2808.js\",\"3iFld\",\"90msp-RKSJ-V.aa85de80.js\",\"6XUCn\",\"90pv-RKSJ-H.848d9bac.js\",\"8eJG6\",\"90pv-RKSJ-V.92513b15.js\",\"iveJ5\",\"Add-H.729159c7.js\",\"kOqxj\",\"Add-RKSJ-H.2baf4c23.js\",\"1zYOj\",\"Add-RKSJ-V.24c188d0.js\",\"2MU2T\",\"Add-V.f276585e.js\",\"oH9eX\",\"Adobe-CNS1-0.c94fb46d.js\",\"fSa6m\",\"Adobe-CNS1-1.22c8a053.js\",\"g2oEO\",\"Adobe-CNS1-2.b6e41c65.js\",\"8WzHR\",\"Adobe-CNS1-3.6168987e.js\",\"ca0bh\",\"Adobe-CNS1-4.44238a8c.js\",\"cfcpu\",\"Adobe-CNS1-5.62d26997.js\",\"li5lK\",\"Adobe-CNS1-6.7ebee211.js\",\"kujwR\",\"Adobe-CNS1-UCS2.0dd5c8ce.js\",\"8iFzj\",\"Adobe-GB1-0.249f5de6.js\",\"6D5co\",\"Adobe-GB1-1.74dabbbf.js\",\"cfFSd\",\"Adobe-GB1-2.4a68d0c8.js\",\"exff1\",\"Adobe-GB1-3.b5b05f5d.js\",\"aeuVs\",\"Adobe-GB1-4.c9dd9584.js\",\"aLrjO\",\"Adobe-GB1-5.0e92a2eb.js\",\"j3PYN\",\"Adobe-GB1-UCS2.bb70ebea.js\",\"d0uYO\",\"Adobe-Japan1-0.4d890a6e.js\",\"eEcvV\",\"Adobe-Japan1-1.a0781bed.js\",\"820v9\",\"Adobe-Japan1-2.9f2dc797.js\",\"frVgA\",\"Adobe-Japan1-3.15951cff.js\",\"jdQzX\",\"Adobe-Japan1-4.0cfae895.js\",\"Z8yoS\",\"Adobe-Japan1-5.66dd1b5b.js\",\"k2vqy\",\"Adobe-Japan1-6.7e06fceb.js\",\"kgt4y\",\"Adobe-Japan1-UCS2.e121ba74.js\",\"eP0RM\",\"Adobe-Korea1-0.ab6029ff.js\",\"gA5f7\",\"Adobe-Korea1-1.f58d7af7.js\",\"i4Ed8\",\"Adobe-Korea1-2.90e46d21.js\",\"l6X7m\",\"Adobe-Korea1-UCS2.37651d5b.js\",\"aphLF\",\"B5-H.35e26a2d.js\",\"7EoeH\",\"B5-V.af3f0204.js\",\"6Q7ZY\",\"B5pc-H.e4f1d7a8.js\",\"8cnq9\",\"B5pc-V.8f5377c3.js\",\"7NcV5\",\"CNS-EUC-H.6bb831b5.js\",\"cxpt9\",\"CNS-EUC-V.8c378414.js\",\"l27ve\",\"CNS1-H.ea7d046f.js\",\"c6rCW\",\"CNS1-V.1fdf3e4e.js\",\"3upsV\",\"CNS2-H.705fd9e8.js\",\"k9G9k\",\"CNS2-V.c55f4d63.js\",\"bDgpL\",\"ETHK-B5-H.7f8e45d5.js\",\"33eqd\",\"ETHK-B5-V.09bf3c22.js\",\"5F3PA\",\"ETen-B5-H.05fb1408.js\",\"hfiT2\",\"ETen-B5-V.5e380c42.js\",\"jMuj8\",\"ETenms-B5-H.3891364b.js\",\"gNTCu\",\"ETenms-B5-V.394705ca.js\",\"6rTQb\",\"EUC-H.b991c232.js\",\"l89SH\",\"EUC-V.0ac4677e.js\",\"iEkij\",\"Ext-H.5968bae5.js\",\"eVVKx\",\"Ext-RKSJ-H.d9938a5e.js\",\"kL3q4\",\"Ext-RKSJ-V.e9a51cbe.js\",\"avDfo\",\"Ext-V.74d1f996.js\",\"l3LgN\",\"GB-EUC-H.910bba6d.js\",\"eIBS8\",\"GB-EUC-V.0c6edfac.js\",\"8HXb3\",\"GB-H.92bed904.js\",\"lWK2A\",\"GB-V.4564569a.js\",\"iYIwI\",\"GBK-EUC-H.f5f68a8f.js\",\"g4Lp1\",\"GBK-EUC-V.97682197.js\",\"9jlRI\",\"GBK2K-H.edc4a051.js\",\"g2IgM\",\"GBK2K-V.46c62554.js\",\"24SBU\",\"GBKp-EUC-H.da565c58.js\",\"gzU5W\",\"GBKp-EUC-V.d5927fe2.js\",\"jN4tb\",\"GBT-EUC-H.267ac8c0.js\",\"6fVUl\",\"GBT-EUC-V.7720b25f.js\",\"e0AMV\",\"GBT-H.974fe797.js\",\"htjXf\",\"GBT-V.12defd7a.js\",\"hWeIU\",\"GBTpc-EUC-H.43d524d7.js\",\"1eaMl\",\"GBTpc-EUC-V.c77ba0fc.js\",\"fDvqM\",\"GBpc-EUC-H.08408830.js\",\"2de5A\",\"GBpc-EUC-V.ddbe12a3.js\",\"19tEv\",\"H.8a76eaa0.js\",\"j0hRA\",\"HKdla-B5-H.e6a4bedb.js\",\"fd9qd\",\"HKdla-B5-V.94816590.js\",\"e9cdN\",\"HKdlb-B5-H.41238054.js\",\"aNHZK\",\"HKdlb-B5-V.c7a56f0d.js\",\"hgC4a\",\"HKgccs-B5-H.423aefeb.js\",\"eEaBv\",\"HKgccs-B5-V.fff775c8.js\",\"fYV0G\",\"HKm314-B5-H.60d4b9bb.js\",\"dJs80\",\"HKm314-B5-V.997bace9.js\",\"4Y1kq\",\"HKm471-B5-H.0a6f2053.js\",\"hYpsA\",\"HKm471-B5-V.5588cb3b.js\",\"9xkOt\",\"HKscs-B5-H.cbf6db19.js\",\"lm69C\",\"HKscs-B5-V.cf9a31dc.js\",\"kva4v\",\"Hankaku.ca0ba78b.js\",\"5AfTB\",\"Hiragana.85378b4a.js\",\"3TaY6\",\"KSC-EUC-H.aff5022e.js\",\"8wf7j\",\"KSC-EUC-V.3949c72d.js\",\"cgHyF\",\"KSC-H.4ed431c9.js\",\"cxq0E\",\"KSC-Johab-H.22d6dfec.js\",\"ipw37\",\"KSC-Johab-V.0ee59f70.js\",\"aD76K\",\"KSC-V.dc2b8859.js\",\"8okaY\",\"KSCms-UHC-H.b54f6070.js\",\"i7fxp\",\"KSCms-UHC-HW-H.998acbf6.js\",\"7fYMC\",\"KSCms-UHC-HW-V.0a3c59db.js\",\"imOx6\",\"KSCms-UHC-V.37c6be44.js\",\"gKF8I\",\"KSCpc-EUC-H.4cfc83d8.js\",\"9m5PS\",\"KSCpc-EUC-V.5881e143.js\",\"8asvD\",\"Katakana.321c2f5f.js\",\"7HkN3\",\"NWP-H.6a69fa60.js\",\"isnju\",\"NWP-V.88613bd5.js\",\"f31m2\",\"RKSJ-H.2af2abd8.js\",\"2VYvR\",\"RKSJ-V.65a07798.js\",\"1KF3Q\",\"Roman.ca13d8f3.js\",\"29QIq\",\"UniCNS-UCS2-H.f2596cac.js\",\"dVqyh\",\"UniCNS-UCS2-V.4be9430a.js\",\"7UKDA\",\"UniCNS-UTF16-H.bb71adc5.js\",\"Q9KG4\",\"UniCNS-UTF16-V.d89c4950.js\",\"c2z6B\",\"UniCNS-UTF32-H.6ef36f87.js\",\"lTznr\",\"UniCNS-UTF32-V.c838593e.js\",\"7t7V6\",\"UniCNS-UTF8-H.77d5771f.js\",\"lcMXU\",\"UniCNS-UTF8-V.70a7ba9f.js\",\"4Y11P\",\"UniGB-UCS2-H.1303e3c8.js\",\"6MnqR\",\"UniGB-UCS2-V.c4668ab1.js\",\"eQt1R\",\"UniGB-UTF16-H.d1be3be2.js\",\"fm8Lw\",\"UniGB-UTF16-V.a072ba07.js\",\"4l8L7\",\"UniGB-UTF32-H.e2d1c79f.js\",\"1tDis\",\"UniGB-UTF32-V.76c200be.js\",\"2Vv5T\",\"UniGB-UTF8-H.41f4baba.js\",\"iWa77\",\"UniGB-UTF8-V.8ed42052.js\",\"38Eab\",\"UniJIS-UCS2-H.e0c99f94.js\",\"lDeVy\",\"UniJIS-UCS2-HW-H.2086623a.js\",\"8aWy7\",\"UniJIS-UCS2-HW-V.ffb2caeb.js\",\"76QHL\",\"UniJIS-UCS2-V.21ffe4a5.js\",\"lRW10\",\"UniJIS-UTF16-H.4216604d.js\",\"aJpvy\",\"UniJIS-UTF16-V.48b4e738.js\",\"7s6rx\",\"UniJIS-UTF32-H.038159ea.js\",\"jUs4H\",\"UniJIS-UTF32-V.34681c47.js\",\"a8YIF\",\"UniJIS-UTF8-H.3f187918.js\",\"fH9Jk\",\"UniJIS-UTF8-V.dd6be6a0.js\",\"13MuZ\",\"UniJIS2004-UTF16-H.c4a60299.js\",\"hwfXT\",\"UniJIS2004-UTF16-V.2dbaf4f4.js\",\"dGSeC\",\"UniJIS2004-UTF32-H.dba66596.js\",\"9rrYA\",\"UniJIS2004-UTF32-V.74761cad.js\",\"7d1OI\",\"UniJIS2004-UTF8-H.4ec8549f.js\",\"809oM\",\"UniJIS2004-UTF8-V.c5cc5b20.js\",\"bdrR8\",\"UniJISPro-UCS2-HW-V.4031e777.js\",\"4D2EW\",\"UniJISPro-UCS2-V.5072efde.js\",\"cdY8a\",\"UniJISPro-UTF8-V.7adee45d.js\",\"avqzB\",\"UniJISX0213-UTF32-H.56363b94.js\",\"j845q\",\"UniJISX0213-UTF32-V.6e415ebf.js\",\"emImx\",\"UniJISX02132004-UTF32-H.80a3d411.js\",\"f6AOW\",\"UniJISX02132004-UTF32-V.75e044a9.js\",\"7pSug\",\"UniKS-UCS2-H.4ff5f169.js\",\"465mT\",\"UniKS-UCS2-V.af99e23d.js\",\"3w6Hd\",\"UniKS-UTF16-H.b031c3f9.js\",\"4T3rW\",\"UniKS-UTF16-V.dbaec3f8.js\",\"d8Hqs\",\"UniKS-UTF32-H.11f34035.js\",\"77ADK\",\"UniKS-UTF32-V.344d4ef0.js\",\"dkDCu\",\"UniKS-UTF8-H.a4bf67c4.js\",\"8Qdf7\",\"UniKS-UTF8-V.af9521f3.js\",\"bhNwf\",\"V.5ce814bb.js\",\"ioEN1\",\"WP-Symbol.9e3226a6.js\",\"edP6u\",\"home.9c6d2e67.js\",\"2OhRQ\",\"codeViewerRenderer.29c899a3.js\",\"3wpjh\",\"image.4dcab477.js\",\"869mA\",\"video.f359eb55.js\",\"j7Vtd\",\"audio.b8a5bcaa.js\",\"f33Ay\",\"doc.c719a94c.js\",\"2JEgu\",\"codeViewer.50fd71a1.js\",\"93dCk\",\"codeViewer.71b6c0bb.js\",\"01BDc\",\"dist.f36f7d00.js\",\"jneCP\",\"dist.adf4c603.js\",\"7sleH\",\"dist.21a5cb52.js\",\"3lBx7\",\"dist.82105929.js\",\"1EgQg\",\"dist.7c7ec582.js\",\"iWiJK\",\"dist.03768f8e.js\",\"gkT8b\",\"dist.11d30e66.js\",\"lLY5F\",\"dist.521fa1db.js\",\"7BCTg\",\"dist.daadd8cb.js\",\"jD4Pj\",\"dist.0c350558.js\",\"217bQ\",\"dist.563e7eec.js\",\"3AIgh\",\"dist.a75fea7a.js\",\"3WBDc\",\"dist.b344a93f.js\",\"gnPOt\",\"dist.761f9dfc.js\",\"73p2H\",\"dist.0397e21f.js\",\"22pEl\",\"dist.8b39c40c.js\",\"cgrQ3\",\"dist.a04ab887.js\",\"5BOC6\",\"dist.30663d49.js\",\"b3fvV\",\"dist.37416658.js\",\"ajqM4\",\"dist.9ab582a8.js\",\"jjPUS\",\"apl.b81e50f9.js\",\"h9FOd\",\"asciiarmor.8042d41d.js\",\"aCljb\",\"asn1.a9aaf8f7.js\",\"lE1F7\",\"asterisk.f4595367.js\",\"aXFnX\",\"brainfuck.4bd8ce2f.js\",\"gkO56\",\"cobol.30d0d372.js\",\"aXQyM\",\"clike.34bb1d46.js\",\"diAFJ\",\"clojure.21077391.js\",\"d7yTx\",\"css.3d1ff96e.js\",\"b2YDT\",\"cmake.0e3e455b.js\",\"4ga7U\",\"coffeescript.c2281a85.js\",\"cZ3D7\",\"commonlisp.97a06575.js\",\"qaaCs\",\"cypher.b80fd281.js\",\"9Fcz0\",\"python.f5111821.js\",\"6RZjl\",\"crystal.a0197265.js\",\"ji1Kk\",\"d.42c2683e.js\",\"2L5Mz\",\"diff.cdb11d67.js\",\"lmz4e\",\"dockerfile.70f43558.js\",\"814bh\",\"dtd.11778cc2.js\",\"7XVNh\",\"dylan.468e767f.js\",\"hGS6V\",\"ebnf.30d80091.js\",\"592ir\",\"ecl.5a273c1a.js\",\"hPiIc\",\"eiffel.85a912d8.js\",\"7wfVk\",\"elm.77c03e04.js\",\"ebMo8\",\"erlang.6dc9b335.js\",\"5h0BU\",\"sql.83903d9f.js\",\"bE4uu\",\"factor.91d4bca2.js\",\"7Mgt2\",\"fcl.8ab4c522.js\",\"bOI1J\",\"forth.3c528cb4.js\",\"bmWQh\",\"fortran.e0029ed4.js\",\"kHxTh\",\"mllike.153cf519.js\",\"6MC1n\",\"gas.a7bccbc7.js\",\"lNBbh\",\"gherkin.3957c5fc.js\",\"bYMjO\",\"groovy.2c7c6877.js\",\"kIBZl\",\"haskell.27501ac4.js\",\"3uMSv\",\"haxe.54a5898e.js\",\"9vuGq\",\"http.bc2057b4.js\",\"1eHix\",\"idl.b9661b63.js\",\"7kn4A\",\"javascript.398b6ea8.js\",\"j4qEZ\",\"jinja2.a602283d.js\",\"3ozoR\",\"julia.eb339e67.js\",\"3DTzS\",\"livescript.a061dc12.js\",\"hURlP\",\"lua.1771bd2a.js\",\"2gQjS\",\"mirc.df514b63.js\",\"hoU9b\",\"mathematica.4b8aab4c.js\",\"40pAI\",\"modelica.f8eb4cea.js\",\"i5YKF\",\"mumps.cf82c6f0.js\",\"hIeWi\",\"mbox.e4169567.js\",\"8q3KK\",\"nginx.5d266b03.js\",\"1VXLT\",\"nsis.e4e191fa.js\",\"bAq00\",\"ntriples.12b53fef.js\",\"aEtpl\",\"octave.05b71169.js\",\"hfTKk\",\"oz.0938f362.js\",\"hTqBJ\",\"pascal.39d89476.js\",\"5ukWe\",\"perl.52765d5b.js\",\"3XLd5\",\"pig.0fb008c2.js\",\"2QavN\",\"powershell.f53ac67c.js\",\"ch01A\",\"properties.ff60ea69.js\",\"7inaT\",\"protobuf.c983d409.js\",\"cJ7mc\",\"pug.9abece4a.js\",\"5NvMz\",\"puppet.b9ab89df.js\",\"ego66\",\"q.aaa15180.js\",\"hj2Rh\",\"r.0b08b779.js\",\"b7tzx\",\"rpm.685318b2.js\",\"3YkAH\",\"ruby.04bb2af8.js\",\"cf92i\",\"sas.9ff0311d.js\",\"8W2eu\",\"scheme.a36ef94c.js\",\"lcrbq\",\"shell.d5f15f17.js\",\"98Pr8\",\"sieve.f0f2cb2c.js\",\"9dDWH\",\"smalltalk.33729233.js\",\"lrUqt\",\"solr.21ea773c.js\",\"bfOqz\",\"sparql.554ff633.js\",\"glXdM\",\"spreadsheet.cd8b4101.js\",\"b9USS\",\"stylus.7e0a4e39.js\",\"kPthK\",\"swift.633d1fa8.js\",\"jsCJL\",\"stex.8d5212f6.js\",\"abYjx\",\"verilog.d22265d7.js\",\"d7Hao\",\"tcl.ced1f258.js\",\"axn6R\",\"textile.51355a0b.js\",\"jDwZc\",\"tiddlywiki.5e83d78f.js\",\"ejPOn\",\"tiki.6fb365f5.js\",\"jx5LN\",\"toml.84dc3c91.js\",\"lsrGy\",\"troff.f7dd2860.js\",\"caKW9\",\"ttcn.4a33ec37.js\",\"6cyuP\",\"ttcn-cfg.5ae2f58f.js\",\"kezEf\",\"turtle.ed16c466.js\",\"ec2k9\",\"webidl.32e06ad6.js\",\"gQivI\",\"vb.278bc558.js\",\"1MGG6\",\"vbscript.a342aecd.js\",\"19BgE\",\"velocity.40adbcac.js\",\"4QVhK\",\"vhdl.7cdb96b8.js\",\"5PTeQ\",\"xquery.27819ab6.js\",\"7rV3v\",\"yacas.6d63ee7e.js\",\"lzeGI\",\"z80.2e6d4d2e.js\",\"jZHIh\",\"mscgen.5ea5176c.js\",\"hLKFT\",\"dist.a9b48aa5.js\",\"4ZwHa\",\"dist.83c91e9c.js\",\"gQYJt\",\"svg.0f44db18.js\",\"gFHfi\",\"zoom-out.db09cd7a.js\",\"4uhcp\",\"zoom-in.5852ad10.js\",\"doomh\",\"chevron-left-circle.db11b726.js\",\"bbnaa\",\"GlobalFeedbackCollector.086787aa.js\",\"8Khwy\",\"GlobalFeedbackCollector.7c1b47d5.js\",\"5Ixal\",\"CreateFolderPopoverItemSpotlight.0dc0692c.svg\",\"6qah4\",\"atl.256998e7.js\",\"lzaHa\",\"FullPageEditorComponent.5844519e.js\",\"aodrz\",\"FullPageEditorComponent.eedad35f.js\",\"g9CVe\",\"mention.28df720c.js\",\"kjZZD\",\"vendors~editor_icon-object.e97fc136.js\",\"ffEVr\",\"vendors~editor_icon.92bb159e.js\",\"16ht2\",\"CreateFromTemplate.39750242.js\",\"hvHZS\",\"TemplatePreview.2b6344f0.js\",\"6JdS4\",\"blogPostIcon.e3cb4562.svg\",\"5fnDv\",\"loadingErrorIcon.3c97c605.svg\",\"bupWa\",\"PopupPreview.b63346ae.js\",\"3yGMH\",\"displayErrorIcon.3bd706b2.svg\",\"4NgYy\",\"ContextualCreateContentPopoverMenu.2ada1402.js\",\"fwbht\",\"ShareButton.f93da2c5.js\",\"clpSH\",\"PageTreeQuickActions.53d44124.js\",\"13PnU\",\"QuickActionsContent.05b00d4a.js\",\"9QyoN\",\"PageQuickActionAutomationMenu.58a3878c.js\",\"05d2I\",\"RendererContentStateWithSpotlight.173338fc.js\",\"9YGIy\",\"DeleteNestedPagesAction.10d2a285.js\",\"iomzR\",\"DeletePageDialog.03d0d714.js\",\"iQ0Jm\",\"UnarchivePagesLoader.00b28304.js\",\"k3BGs\",\"DeleteNestedPagesAction.da65be3a.js\",\"adHzf\",\"DeleteNestedPagesAction.af5a528e.js\",\"72Gwk\",\"nativeEditorComponentsPreloader.52a741af.js\",\"4JUnA\",\"BulkDeletePagesAction.c0f58965.js\",\"5YvMC\",\"BulkChangeOwnerAction.e612d675.js\",\"bXkeF\",\"BulkChangeStatusAction.c76086be.js\",\"leIbB\",\"BulkChangeStatusAction.ec424326.js\",\"1aFR7\",\"NestedChangeOwnerAction.f8ad4630.js\",\"Pp5sV\",\"NestedConvertPageToLiveDocAction.9804acc9.js\",\"lgZ1d\",\"BulkConvertPageToLiveDocAction.14c6b60a.js\",\"p4ay7\",\"CopyPageTreeContainer.1b6761ef.js\",\"dq8Jz\",\"FullPageEditorComponent.f69899ed.js\",\"i5Fj1\",\"data-classification.b4c9db6d.js\",\"jnk96\",\"DataClassification.96a4949a.js\",\"gEi5K\",\"NotFound.6326a8bd.js\",\"QfEJc\",\"NotFoundIcon.ab9d1086.svg\",\"2F69B\",\"vendors~small-pkgs.72a99ece.js\",\"bn8Oy\",\"OverviewNotFound.6fdd31cc.js\",\"4jFyQ\",\"icon-space-overview-empty.106059f9.svg\",\"3b99S\",\"EditorContentClassificationTag.d9726fb7.js\",\"1zPhe\",\"EditorDataClassification.d164af03.js\",\"avzJW\",\"EditorDataClassificationComponent.a0d19f8b.js\",\"4Oj5y\",\"ContentTypeClassification.4e6b4f1b.js\",\"iJsKa\",\"ClassificationReadViewPopup.916ee61f.js\",\"cEDfx\",\"DataClassificationHoverButton.229e6e5c.js\",\"9wTW2\",\"EditorClassificationTagWrapper.f24b8d90.js\",\"2tDVK\",\"UnarchivePagesLoader.5d46e036.js\",\"gLxW3\",\"UnarchivePagesLoader.da52f784.js\",\"bW8TA\",\"CommentEditor.a8a19c97.js\",\"5odbj\",\"ClassificationTagButtonError.1b9558b9.js\",\"4Qstt\",\"ClassificationEditModal.928a4a72.js\",\"58UdM\",\"ClassificationEditViewPopup.c3b1a30d.js\",\"5ko8n\",\"MovePageDialog.9687464c.js\",\"f9QHk\",\"TreeMonitor.3caa2a6d.js\",\"bunf9\",\"Controller.68369bac.js\",\"c4Kdp\",\"GeneralAccessLevelSelector.d9c22a04.js\",\"kxRVH\",\"AccessRequestsButton.c0152879.js\",\"hvjHg\",\"PublicLinkPermissionsSpotlight.328990b4.svg\",\"hFMOd\",\"PublicLinkButtonSpotlight.9320b1e3.svg\",\"k0hwN\",\"ShareToSlack.6b2c86a2.js\",\"lVO4z\",\"cs.66d17b1d.js\",\"2FVbf\",\"da.45f5bf76.js\",\"ljo6M\",\"de.87ff8d2a.js\",\"9lT7a\",\"en_GB.3f736bc3.js\",\"cNgJs\",\"en.53674b7a.js\",\"aHeMo\",\"en_ZZ.90d281af.js\",\"8d6ia\",\"es.44f7b6ae.js\",\"jh8UJ\",\"fi.bd46bce1.js\",\"bYwCr\",\"fr.854524fc.js\",\"11NiT\",\"hu.21eb6dc5.js\",\"le8VA\",\"it.111da4a0.js\",\"1beJ2\",\"ja.25f13916.js\",\"1tXCh\",\"ko.c7b3c730.js\",\"jzP8g\",\"nb.6ab8a8d0.js\",\"dJY66\",\"nl.b11fd7f9.js\",\"4foYW\",\"pl.200ddf23.js\",\"j0yc3\",\"pt_BR.3fad7d31.js\",\"RfEmw\",\"ru.64b44490.js\",\"5DOlG\",\"sv.812498a9.js\",\"6rD7n\",\"tr.6280d059.js\",\"1e62a\",\"th.646e04f8.js\",\"eLsCU\",\"uk.87a103d8.js\",\"g9qHs\",\"vi.352e605d.js\",\"2ri5s\",\"zh_TW.40e2425f.js\",\"3k60n\",\"zh.af15c051.js\",\"hxIYN\",\"integration-primer.cead19d9.svg\",\"5oKDR\",\"disabled-alert.0ba0a4e5.svg\",\"dIuhJ\",\"link-filled.19c799b9.js\",\"f9XGo\",\"CoreInvites.aa007e38.js\",\"e39BD\",\"SlackTeamsSpotlight.4131c6b4.js\",\"fniFO\",\"Ed.971a9eb8.svg\",\"b5Vj8\",\"Katina.a5091468.svg\",\"aNfB2\",\"Myra.bfce28e5.svg\",\"jpChu\",\"Oliver.efa0d68b.svg\",\"3IQHf\",\"slackSpotlight.c7655f37.svg\",\"35VU5\",\"cs.d801dcbc.js\",\"6W6gh\",\"da.bac7ddcf.js\",\"bfTAm\",\"de.c95398fc.js\",\"fP9up\",\"en_GB.98e5ca88.js\",\"hc0i6\",\"en.8117d663.js\",\"15E48\",\"en_ZZ.00ef7c85.js\",\"jLWG0\",\"es.7e41636e.js\",\"9J49E\",\"fi.89090e5d.js\",\"br9SP\",\"fr.2a048ea9.js\",\"5h4sF\",\"hu.c2dc4635.js\",\"1MV5Z\",\"it.05b27b71.js\",\"iV5Fv\",\"ja.7b259d22.js\",\"7R5mJ\",\"ko.203f86ca.js\",\"5XMUp\",\"nb.e44f5efd.js\",\"jaDFz\",\"nl.405ee529.js\",\"LOg5S\",\"pl.23c5179b.js\",\"lnJdQ\",\"pt_BR.805e95d7.js\",\"hqsLl\",\"ru.c980f637.js\",\"j0btO\",\"sv.9635f53d.js\",\"2YEqr\",\"tr.ddf2ab95.js\",\"7zFV7\",\"th.3ecc11fa.js\",\"fZ22O\",\"uk.04a59e12.js\",\"4tleS\",\"vi.cca22a6d.js\",\"bE6tX\",\"zh_TW.af40ed8f.js\",\"esYD7\",\"zh.8eeac7b4.js\",\"7oczk\",\"cs.f94e9acb.js\",\"e2gl6\",\"da.452fc83f.js\",\"9oo3s\",\"de.e603f414.js\",\"fRPrc\",\"en_GB.113ccfd3.js\",\"dC0KT\",\"en.2f60c19a.js\",\"gbKsh\",\"en_ZZ.71260efd.js\",\"1ZyUV\",\"es.30208975.js\",\"6tijD\",\"et.a748dc81.js\",\"6fkVy\",\"fi.6cd6b4f0.js\",\"5nw5x\",\"fr.183ce9c7.js\",\"jK12s\",\"hu.f759293a.js\",\"6lWvL\",\"is.e7fee0c5.js\",\"kk9To\",\"it.4d1316fd.js\",\"lyt83\",\"ja.8bae3143.js\",\"2uvfp\",\"ko.c72b821f.js\",\"4Wx8B\",\"nb.6f591f7c.js\",\"huTg5\",\"nl.19b2af2c.js\",\"fPfEd\",\"pl.d1f6bfb2.js\",\"fTYhL\",\"pt_BR.dc22514f.js\",\"dVHhf\",\"pt_PT.137566ba.js\",\"2SsCI\",\"ro.a2a72a07.js\",\"kVi5E\",\"ru.20b35c16.js\",\"6HoYh\",\"sk.63554299.js\",\"kOAvl\",\"sv.9189f5e0.js\",\"5ErHy\",\"tr.da3f85c6.js\",\"jJzpI\",\"th.32ffc0a2.js\",\"2PvRH\",\"uk.7f0edb44.js\",\"eUGjU\",\"vi.f2681927.js\",\"drbCf\",\"zh_TW.356972f3.js\",\"5dk6T\",\"zh.063dc4ca.js\",\"7pAFt\",\"WarningIllustration.8adc2aae.js\",\"2CfIU\",\"WarningIllustration.ec26752f.png\",\"13QWg\",\"in-trial-feature-gates-banner.8806b663.js\",\"g7QTt\",\"CoreInvites.aa4f9f3f.js\",\"i0gb6\",\"CoreInvites.runtime.e67fa744.js\",\"1TOYq\",\"CoreInvites.0dca447d.js\",\"gkmZg\",\"DevToolsDialog.0f875530.js\",\"i3TSs\",\"RestrictionsDialog.c04d446a.js\",\"85liN\",\"InspectPermissionsDialog.78171eaf.js\",\"dTsOE\",\"modal.dc2d010b.js\",\"14XOE\",\"InspectPermissionsDialog.27088c8e.js\",\"69XGw\",\"InspectPermissionsEntryPoint.b4a635c5.js\",\"8sFYu\",\"RestrictionsDialog.7c7444f1.js\",\"iO9O1\",\"personal_space.c63f5733.png\",\"34k9U\",\"ObjectSidebarControl.cff47818.js\",\"k8hvy\",\"ObjectSidebarControl.runtime.e284ad02.js\",\"i0gb6\",\"CoreInvites.runtime.e67fa744.js\",\"k8hvy\",\"ObjectSidebarControl.runtime.e284ad02.js\",\"aoUod\",\"MoveBlogModal.d88c6412.js\",\"2Qrvo\",\"QuickActionsContent.579d88b7.js\",\"kRtpG\",\"QuickActionsContent.db7e4d94.js\",\"3D26r\",\"QuickActionsContent.runtime.c5277c5f.js\",\"3D26r\",\"QuickActionsContent.runtime.c5277c5f.js\",\"PNyg1\",\"InlineRename.7ba3b483.js\",\"emopq\",\"MovePageDialog.81048606.js\",\"3L1uC\",\"PageTreeErrorComponent.b558e03e.js\",\"dhqJV\",\"FooterCreateButtons.84da1680.js\",\"67Pvd\",\"ContentTreeOnboarding.c05390e9.js\",\"e19Zv\",\"LiveDocsIconTile.31afeae9.js\",\"d1QkY\",\"TreeBottomCreateButton.b548d881.js\",\"fnoJZ\",\"HomepageIcon.129a4e5b.js\",\"6gau7\",\"DraftLozenge.b210c68f.js\",\"5zDuS\",\"NativeCollabComponent.2d426b34.js\",\"8S7hU\",\"ContentWrapperSpotlightGIF-dark.bbe9839d.gif\",\"7P169\",\"ContentWrapperSpotlightGIF-light.9900190e.gif\",\"hOsjc\",\"ResolvedInlineCommentsDialog.2314d83a.js\",\"km34l\",\"ResolvedInlineCommentsQueryRenderer.92a4bfa8.js\",\"aS96v\",\"ResolvedInlineCommentsCounter.8d1f2cd8.js\",\"fJjZJ\",\"PublishPageAsBlogDialog.8de2d772.js\",\"iY5MP\",\"EllipsisDropdown.a20185d7.js\",\"1fnbu\",\"EditLabelDialogComponent.79b33036.js\",\"1kb22\",\"LabelsSelect.48be988a.js\",\"a7qwF\",\"LabelsSelectErrors.e6b3fe39.js\",\"lJJQ8\",\"ViewChangesDialog.4c0c0f77.js\",\"8OiWl\",\"ChangesDiff.9deb5b01.js\",\"zKI0V\",\"LivePagesExpandedEapConversionSpotlight.98b4ca3b.js\",\"6nou4\",\"switchToLiveEditingImage.67d7f4d5.svg\",\"fOegz\",\"EditorPresenceAvatarGroup.5227fc53.js\",\"kPKOV\",\"AgentProfileCard.6e0835d0.js\",\"c9Qqc\",\"auto-dev.998d58bd.js\",\"1TK6P\",\"auto-fix.07790e95.js\",\"grvAy\",\"auto-review.eb6c556a.js\",\"23K0q\",\"backlog-buddy.77803ebe.js\",\"3kQkj\",\"comms-crafter.37031eba.js\",\"6OXgE\",\"culture.46528ca4.js\",\"cbucA\",\"customer-insight.b71811cb.js\",\"bVhr1\",\"decision-director.cdf61897.js\",\"kE0QC\",\"feature-flag-avatar.c60bd9d5.js\",\"eVFXf\",\"generic-avatar.0faf04ac.js\",\"9FhBz\",\"hire-writer.9e73f27f.js\",\"6zB8z\",\"marketing-message-maestro.d95d5d6b.js\",\"eENGY\",\"my-user-manual.277d400f.js\",\"hmlb0\",\"okr-oracle.501b2473.js\",\"2NGxc\",\"ops-agent.6b999ec1.js\",\"bPgcq\",\"pitch-perfector.33d8fc56.js\",\"31b1q\",\"product-requirement.2b164fec.js\",\"8Lh9U\",\"release-notes.c909e5c4.js\",\"6ZzYJ\",\"research-scout.6dccd2a5.js\",\"410SS\",\"social-media-scribe.404e9147.js\",\"z3s9q\",\"team-connection.62db7c27.js\",\"9gqcE\",\"workflow-builder.48a79198.js\",\"2u53D\",\"CommentEditor.634d666b.js\",\"2KJHS\",\"esm.90a6c55b.js\",\"eb06U\",\"AgentProfileCard.16f77680.js\",\"7XPb0\",\"Whiteboard.f23600b1.js\",\"34R0T\",\"AgentPresence.13e3f0e2.js\",\"gIMXh\",\"FollowCursorOnboardingHeader.4193dac1.svg\",\"9y1Aa\",\"WhiteboardGAModalManager.8596e65c.js\",\"dIuWY\",\"GAOnboardingAnnouncement.98a7a653.gif\",\"ldbKE\",\"VersionHistoryModalManager.bd48fca2.js\",\"9Ue7m\",\"VersionHistoryModalImg.0f4254f6.svg\",\"3u6ne\",\"WhiteboardTeammateLight.c29609b9.svg\",\"1TWTl\",\"WhiteboardTeammateDark.718ee45a.svg\",\"jXE7i\",\"FullPageEditorComponent.5e823c36.js\",\"9L8th\",\"FullPageEditorComponent.55390cf3.js\",\"7S4dn\",\"FullPageEditorComponent.18c208aa.js\",\"89b92\",\"PublishButtonWithMoreOptions.51f90e8c.js\",\"inQqk\",\"RestrictionsDialog.e9acd9a1.js\",\"9NxYX\",\"no-restriction-illustration-Light.a376c323.svg\",\"lpZU0\",\"no-restriction-illustration-Dark.8da66227.svg\",\"kgrX3\",\"no-restriction-illustration-pencil-Light.bcc52320.svg\",\"bRk6k\",\"no-restriction-illustration-pencil-Dark.5e6368e9.svg\",\"1DRtS\",\"no-restrictions-illustration-external-share-Light.85b8ab71.svg\",\"hhpRR\",\"no-restrictions-illustration-external-share-Dark.dff9aa3b.svg\",\"42PSc\",\"AutomationPremiumTip.a3abb3d2.js\",\"24IdC\",\"Publish-Modal-Background-Image-Light.4e795a9a.svg\",\"dXonJ\",\"Publish-Modal-Background-Image-Dark.cd843bfb.svg\",\"gZ0i8\",\"PublishHubDialog.8c895718.js\",\"57vSc\",\"PublishButtonWithMoreOptions.637f20c9.js\",\"anQQJ\",\"PublishModal.fe142cb5.js\",\"iQam7\",\"page.6c3ca97c.svg\",\"jIvk7\",\"whiteboard.d5787185.svg\",\"cuVen\",\"PublishButtonWithMoreOptions.f7a815a2.js\",\"fCqMy\",\"DiscardModal.4847d4f2.js\",\"a6uKK\",\"CancelSchedulePublishModal.bbc4760e.js\",\"h2HOI\",\"PublishModalMountPoint.de2965cb.js\",\"kXcA7\",\"PublishModalKeyboardShortcuts.926c177f.js\",\"3xec3\",\"LivePagesEllipsisDropdown.376498cd.js\",\"2nHxT\",\"QRCodeComponent.be5dcb3a.js\",\"289Xl\",\"customCursor.8a87402c.svg\",\"9IaUU\",\"Navigation.9892b18f.js\",\"62AD8\",\"SettingsMenu.0101c953.js\",\"dC3sP\",\"ContentTools.407a3570.js\",\"4TY0p\",\"ContentToolsItemWithRoutesContext.0689d78d.js\",\"bzc8Q\",\"ContentToolsItem.73798652.js\",\"7jBYv\",\"nativeEditorComponentsPreloader.d731ef04.js\",\"hbc6v\",\"TitleAreaContentComponents.3e3099b5.js\",\"kW5ll\",\"EditorAppearanceButtonComponent.6939ce41.js\",\"7GtpA\",\"EditorAppearanceButtonNext.4dc7a045.js\",\"l5zX1\",\"ReadTime.ced688d2.js\",\"17JTB\",\"modal.ab3296f0.js\",\"cMAQT\",\"DropboxIcon.a8826e5f.js\",\"9n0AM\",\"dropboxscript.62f72250.js\",\"8AwXG\",\"ProjectLinker.3eafb1fd.js\",\"j0KqR\",\"jira-board-light.49fc2d6c.png\",\"aEOsg\",\"jira-board-dark.4f2096de.png\",\"chv15\",\"jira-static-light.fe57e5bd.png\",\"5koHF\",\"jira-static-dark.ec3cbc0d.png\",\"6Z8WE\",\"en.3315bf41.js\",\"c0JsV\",\"link-picker.1ea52dc1.js\",\"avCUM\",\"chevron-left.d78b2f60.js\",\"jCu7l\",\"FullPageEditorComponent.b88a755d.js\",\"2HlAY\",\"root-component.e599dff3.js\",\"hXu5I\",\"plussquare.b31ea70a.js\",\"kkycx\",\"issue-raise.84b6c161.js\",\"7lyIx\",\"page.d018348a.js\",\"esvqD\",\"page.97006ff6.js\",\"a0oMZ\",\"ui.f8d2c3b0.js\",\"8KDBK\",\"inline-create-one-step-experiment.c2c056f4.js\",\"6XNSn\",\"codeBlockAdvanced.d3232e06.js\",\"6qRJw\",\"dist.a90fea49.js\",\"1Wolg\",\"dist.b936756b.js\",\"fNNWn\",\"dist.e67d127a.js\",\"dnE79\",\"editor-ai-opt-in-banner.523b2454.svg\",\"6z3SN\",\"BrowseRovoAgentsModal.194f4cd2.js\",\"d2yzT\",\"AgentProfileCard.11f04c03.js\",\"erM4f\",\"star-filled.1f795fb2.js\",\"6FSEq\",\"star.e20ad96e.js\",\"g2v3v\",\"BrowseRovoAgentsModal.fef565ae.js\",\"g7pmM\",\"suitcase.f52e8c15.js\",\"cCo7G\",\"cs.1990b7aa.js\",\"2yaNi\",\"da.a8b3e286.js\",\"1bqZ7\",\"de.2ecfcecb.js\",\"dtcDt\",\"en_GB.3327ebf6.js\",\"bbNMp\",\"en.3c1c8377.js\",\"jmeku\",\"en_ZZ.33c975a9.js\",\"gvu1P\",\"es.f9ddf840.js\",\"77OtH\",\"fi.82764f00.js\",\"kwpyS\",\"fr.026f878e.js\",\"jR65k\",\"hu.45a5801e.js\",\"hjKsx\",\"it.c62a7adf.js\",\"7SU8v\",\"ja.de33cd16.js\",\"6CkyE\",\"ko.b651f3f7.js\",\"9jxAI\",\"nb.7760e080.js\",\"gipQq\",\"nl.b8add44b.js\",\"lGaKH\",\"pl.091829d1.js\",\"cnozD\",\"pt_BR.7830f082.js\",\"576vh\",\"ru.bd7ad7e5.js\",\"6TNAX\",\"sv.dc533dc0.js\",\"7DeyD\",\"tr.eb8480f5.js\",\"hshW4\",\"th.2ec6b0ff.js\",\"lqXcv\",\"uk.286130b8.js\",\"fTQUk\",\"vi.6b1e9844.js\",\"hqXjy\",\"zh_TW.654e13e7.js\",\"5DEnz\",\"zh.38cc7b68.js\",\"4kOrv\",\"SaveCompanyHubConfirmationModal.6957e1cc.js\",\"N69Ko\",\"PreviewBanner.6705398a.svg\",\"lffTV\",\"PreviewBanner-dark.692d372a.svg\",\"3Kg3S\",\"CreateComponent.37c4d648.js\",\"aHCaB\",\"ViewComponent.a1055e67.js\",\"dVM1q\",\"EditorPageCoverPictureEntry.62aeaca3.js\",\"gGhXk\",\"EditorPageCoverPicture.aed68b6b.js\",\"hqblC\",\"browser.3ee3fba5.js\",\"fAU2U\",\"EditorPageCoverPicture.0ffeaef7.js\",\"4hycL\",\"NoResults.9d75157a.svg\",\"1CVqv\",\"PreviewPageCoverPicture.53fd9a17.js\",\"4Bg7q\",\"RendererPageCoverPicture.83503a29.js\"]"));


//# sourceMappingURL=NativeCollabComponent.69e00edb.js.map
